// // ModalComponent.js
// import putRequests from "api/put";
// import React, { useState, useEffect } from "react";
// import { useForm } from "react-hook-form";
// import toast from "react-hot-toast";
// import Modal from "react-modal";

// Modal.setAppElement("#root");

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     borderRadius: "20px",
//     width: "400px",
//     padding: "20px",
//     border: "none",
//     boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//   },
//   overlay: {
//     backgroundColor: "rgba(0, 0, 0, 0.75)",
//   },
// };

// let buttonStyle = {
//   background: "#3AC656",
//   color: "white",
//   padding: "12px 20px",
//   margin: "5px",
//   borderRadius: "12px",
//   width: "100%",
//   height: "55px",
//   fontSize: "18px",
//   fontWeight: "600",
//   marginBottom: "8px",
//   zIndex: 3,
// };
// const inputStyles = {
//   padding: "12px, 16px, 12px, 16px",
//   margin: "10px 0",
//   width: "100%",
//   borderColor: "#E4E7EC",
//   borderRadius: "8px",
//   marginBottom: "8px",
// };
// const headingStyle = {
//   color: "#204391",
//   fontSize: "20px",
//   fontWeight: "700",
//   lineHeight: "24.2px",
//   textAlign: "left",
//   gap: "39px",
//   marginBottom: "8px",
// };
// const textStyles = {
//   color: "#606268",
//   fontSize: "14px",
//   fontWeight: "400",
//   lineHeight: "24px",
//   textAlign: "left",
//   marginBottom: "8px",
// };

// const SignUpModal = ({
//   isOpen,
//   onRequestClose,
//   onLoggedIn,
//   processing,
//   handleGetUserLoginDetails,
//   handleUserSignIn,
//   register,
//   getValues,
//   handleSubmit,
//   errors,
//   setValue,
//   step,
//   setStep,
// }) => {
//   const [currentView, setCurrentView] = useState("login"); // Can be 'signup' or 'otp'
//   const [forgotPasswordFlow, setForgotPasswordFlow] = useState(false);
//   const [otp, setOtp] = useState(Array(6).fill(""));
//   const [resetData, setResetData] = useState(null);
//   const [resendTimer, setResendTimer] = useState(0);
//   const [isProcessing, setIsProcessing] = useState(false);

//   const MERCHANT_ID = "MER12193";
//   console.log(resetData, "ressss");

//   useEffect(() => {
//     let interval;
//     if (resendTimer > 0) {
//       interval = setInterval(() => {
//         setResendTimer((prev) => prev - 1);
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [resendTimer]);

//   // useEffect hook to swtich to OTP to deal with the error of too many re-renders
//   useEffect(() => {
//     switch (step) {
//       case 2:
//         setCurrentView("otp");
//         break;
//       default:
//         break;
//     }
//   }, [step]);

//   const handleOTPChange = (element, index) => {
//     if (isNaN(element.value)) return false;
//     const newOtp = [...otp];
//     newOtp[index] = element.value;
//     setOtp(newOtp);

//     // Auto-focus to next input field after a digit is typed
//     if (element.nextSibling && element.value) {
//       element.nextSibling.focus();
//     }
//   };

//   const handleForgotPassword = async () => {
//     const phoneNumber = getValues("mobileNumber");

//     if (!phoneNumber || phoneNumber.length !== 10) {
//       toast.error("Please enter a valid phone number");
//       return;
//     }

//     setIsProcessing(true);
//     try {
//       const payload = {
//         contact: phoneNumber,
//         cus_merchant: MERCHANT_ID,
//       };

//       const response = await putRequests.forgotPassword(payload);

//       console.log(response, "toooooo");

//       if (response?.status === 0 || response?.data) {
//         setResetData(response?.id);
//         setForgotPasswordFlow(true);
//         setCurrentView("forgotPasswordOTP");
//         setResendTimer(30);
//         toast.success("OTP sent successfully!");
//       } else {
//         toast.error(response?.message || "Failed to send OTP");
//       }
//     } catch (error) {
//       console.error("Forgot password error:", error);
//       toast.error("Failed to send OTP. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleResendOTP = async () => {
//     if (resendTimer > 0) return;

//     const phoneNumber = getValues("mobileNumber");
//     setIsProcessing(true);

//     try {
//       const payload = {
//         contact: phoneNumber,
//         cus_merchant: MERCHANT_ID,
//       };

//       const response = await putRequests.forgotPassword(payload);

//       if (response?.status === 0 || response?.data) {
//         setResetData(response?.data);
//         setResendTimer(30);
//         toast.success("OTP resent successfully!");
//       } else {
//         toast.error("Failed to resend OTP");
//       }
//     } catch (error) {
//       console.error("Resend OTP error:", error);
//       toast.error("Failed to resend OTP");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleOTPSubmit = async () => {
//     const otpCode = otp.join("");

//     if (otpCode.length !== 6) {
//       toast.error("Please enter the complete OTP");
//       return;
//     }

//     if (forgotPasswordFlow) {
//       // Move to reset password screen
//       setCurrentView("resetPassword");
//       setValue("otpCode", otpCode);
//     } else {
//       setCurrentView("login");
//       setStep(3);
//     }
//   };

//   const handleResetPassword = async () => {
//     const password = getValues("password");
//     const repeatPassword = getValues("repeatPassword");
//     const otpCode = getValues("otpCode");

//     if (!password || !repeatPassword) {
//       toast.error("Please fill in all fields");
//       return;
//     }

//     if (password !== repeatPassword) {
//       toast.error("Passwords do not match");
//       return;
//     }

//     if (password.length < 6) {
//       toast.error("Password must be at least 6 characters");
//       return;
//     }

//     setIsProcessing(true);
//     try {
//       const payload = {
//         id: resetData,
//         code: otpCode,
//         new_pass: password,
//         cus_merchant: MERCHANT_ID,
//       };

//       const response = await putRequests.resetPassword(payload);

//       if (response?.status === 0) {
//         toast.success("Password reset successfully!");
//         setCurrentView("login");
//         setForgotPasswordFlow(false);
//         setOtp(Array(6).fill(""));
//         setValue("password", "");
//         setValue("repeatPassword", "");
//         setStep(0);
//       } else {
//         toast.error(response?.message || "Failed to reset password");
//       }
//     } catch (error) {
//       console.error("Reset password error:", error);
//       toast.error("Failed to reset password. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
//       <div style={{ textAlign: "center" }}>
//         {/* Toggle between Login and SignUp */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             marginBottom: "20px",
//           }}
//         >
//           <button
//             onClick={() => {
//               setCurrentView("login");
//               setForgotPasswordFlow(false);
//               setStep(0);
//             }}
//             style={{
//               marginRight: "10px",
//               color: currentView === "login" ? "#204391" : "#98A2B3",
//               fontSize: "16px",
//               fontWeight: "600",
//               fontFamily: "inter",
//               padding: "8px",
//               width: "100%",
//             }}
//           >
//             Login
//           </button>
//           {/* <button
//             onClick={switchToSignup}
//             style={{
//               color: currentView === "signup" ? "#204391" : "#98A2B3",
//               fontSize: "16px",
//               fontWeight: "600",
//               fontFamily: "inter",
//               padding: "8px",
//               width: "100%",
//             }}
//           >
//             Sign Up
//           </button> */}
//         </div>
//         <hr style={{ color: "gray", marginTop: "-8px", marginBottom: "8px" }} />
//         {currentView === "login" && !forgotPasswordFlow && (
//           // Login Form
//           <>
//             <div>
//               <p style={headingStyle}>Welcome Back</p>
//               <p style={textStyles}>Enter your phone number and password</p>
//             </div>
//             <input
//               readOnly={step === 1 || step === 3}
//               placeholder="Phone Number"
//               type="tel"
//               maxLength={10}
//               autoComplete="tel"
//               style={inputStyles}
//               {...register("mobileNumber", {
//                 required: "Mobile number is required",
//                 minLength: {
//                   value: 10,
//                   message: `Number must be 10 characters`,
//                 },
//                 maxLength: {
//                   value: 10,
//                   message: `Number must be 10 characters`,
//                 },
//               })}
//             />
//             {step === 1 && (
//               <>
//                 <input
//                   type="password"
//                   placeholder="Password"
//                   autoComplete="current-password"
//                   style={inputStyles}
//                   {...register("password", {
//                     required: "Password is required",
//                   })}
//                 />
//                 <div style={{ textAlign: "right", marginBottom: "8px" }}>
//                   <button
//                     onClick={handleForgotPassword}
//                     style={{
//                       color: "#204391",
//                       fontSize: "14px",
//                       textDecoration: "underline",
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                     }}
//                     disabled={isProcessing}
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>
//               </>
//             )}
//             {step === 3 && (
//               <>
//                 <input
//                   type="password"
//                   placeholder="New Password"
//                   autoComplete="new-password"
//                   style={inputStyles}
//                   {...register("password", {
//                     required: "Password is required",
//                   })}
//                 />
//                 <input
//                   type="password"
//                   placeholder="Confirm Password"
//                   style={inputStyles}
//                   {...register("repeatPassword", {
//                     required: "Password is required",
//                     validate: (value) =>
//                       value === getValues("password") || "Passwords must match",
//                   })}
//                 />
//               </>
//             )}
//             {step === 3 ? (
//               <button
//                 disabled={processing}
//                 style={{
//                   ...buttonStyle,
//                   background: processing ? "#6BFA88" : "#3AC656",
//                 }}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubmit(
//                     getValues("password") === getValues("repeatPassword")
//                       ? handleUserSignIn
//                       : () => toast.error("Passwords do not match"),
//                   )();
//                 }}
//               >
//                 {!processing ? "Register" : "Loading..."}
//               </button>
//             ) : (
//               <button
//                 disabled={processing}
//                 style={{
//                   ...buttonStyle,
//                   background: processing ? "#6BFA88" : "#3AC656",
//                 }}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubmit(
//                     step === 0 ? handleGetUserLoginDetails : handleUserSignIn,
//                   )();
//                 }}
//               >
//                 {!processing ? "Login" : "Loading..."}
//               </button>
//             )}
//           </>
//         )}

//         {currentView === "otp" && (
//           <>
//             <h2 style={headingStyle}>Enter OTP</h2>
//             <p style={textStyles}>
//               Enter the code from the SMS we sent to {getValues("mobileNumber")}
//             </p>
//             <div>
//               {otp.map((data, index) => {
//                 return (
//                   <input
//                     key={index}
//                     type="text"
//                     value={otp[index]}
//                     maxLength="1"
//                     onChange={(e) => handleOTPChange(e.target, index)}
//                     onFocus={(e) => e.target.select()}
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       marginRight: "10px",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                       textAlign: "center",
//                       fontSize: "18px",
//                       border: "1px solid #E4E7EC",
//                       borderRadius: "8px",
//                     }}
//                   />
//                 );
//               })}
//             </div>
//             <button onClick={handleOTPSubmit} style={buttonStyle}>
//               Confirm OTP
//             </button>
//           </>
//         )}

//         {currentView === "forgotPasswordOTP" && (
//           <>
//             <h2 style={headingStyle}>Enter OTP</h2>
//             <p style={textStyles}>
//               Enter the code from the SMS we sent to {getValues("mobileNumber")}
//             </p>
//             <div>
//               {otp.map((data, index) => {
//                 return (
//                   <input
//                     key={index}
//                     type="text"
//                     value={otp[index]}
//                     maxLength="1"
//                     onChange={(e) => handleOTPChange(e.target, index)}
//                     onFocus={(e) => e.target.select()}
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       marginRight: "10px",
//                       marginBottom: "10px",
//                       marginTop: "10px",
//                       textAlign: "center",
//                       fontSize: "18px",
//                       border: "1px solid #E4E7EC",
//                       borderRadius: "8px",
//                     }}
//                   />
//                 );
//               })}
//             </div>
//             <button
//               onClick={handleOTPSubmit}
//               style={buttonStyle}
//               disabled={isProcessing}
//             >
//               {isProcessing ? "Loading..." : "Verify OTP"}
//             </button>
//             <div style={{ marginTop: "10px" }}>
//               <button
//                 onClick={handleResendOTP}
//                 disabled={resendTimer > 0 || isProcessing}
//                 style={{
//                   color: resendTimer > 0 ? "#98A2B3" : "#204391",
//                   fontSize: "14px",
//                   background: "none",
//                   border: "none",
//                   cursor: resendTimer > 0 ? "not-allowed" : "pointer",
//                 }}
//               >
//                 {resendTimer > 0
//                   ? `Resend OTP in ${resendTimer}s`
//                   : "Resend OTP"}
//               </button>
//             </div>
//           </>
//         )}

//         {currentView === "resetPassword" && (
//           <>
//             <h2 style={headingStyle}>Reset Password</h2>
//             <p style={textStyles}>Create a new password for your account</p>
//             <input
//               type="password"
//               placeholder="New Password"
//               style={inputStyles}
//               {...register("password", {
//                 required: "Password is required",
//                 minLength: {
//                   value: 6,
//                   message: "Password must be at least 6 characters",
//                 },
//               })}
//             />
//             <input
//               type="password"
//               placeholder="Confirm Password"
//               style={inputStyles}
//               {...register("repeatPassword", {
//                 required: "Password is required",
//                 validate: (value) =>
//                   value === getValues("password") || "Passwords must match",
//               })}
//             />
//             {errors.password && (
//               <p style={{ color: "red", fontSize: "12px" }}>
//                 {errors.password.message}
//               </p>
//             )}
//             {errors.repeatPassword && (
//               <p style={{ color: "red", fontSize: "12px" }}>
//                 {errors.repeatPassword.message}
//               </p>
//             )}
//             <button
//               onClick={handleSubmit(handleResetPassword)}
//               style={buttonStyle}
//               disabled={isProcessing}
//             >
//               {isProcessing ? "Loading..." : "Reset Password"}
//             </button>
//           </>
//         )}
//       </div>
//     </Modal>
//   );
// };

// export default SignUpModal;
// ModalComponent.js
import putRequests from "api/put";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Modal from "react-modal";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "20px",
    width: "400px",
    padding: "20px",
    border: "none",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

let buttonStyle = {
  background: "#3AC656",
  color: "white",
  padding: "12px 20px",
  margin: "5px",
  borderRadius: "12px",
  width: "100%",
  height: "55px",
  fontSize: "18px",
  fontWeight: "600",
  marginBottom: "8px",
  zIndex: 3,
};
const inputStyles = {
  padding: "12px, 16px, 12px, 16px",
  margin: "10px 0",
  width: "100%",
  borderColor: "#E4E7EC",
  borderRadius: "8px",
  marginBottom: "8px",
};
const headingStyle = {
  color: "#204391",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "24.2px",
  textAlign: "left",
  gap: "39px",
  marginBottom: "8px",
};
const textStyles = {
  color: "#606268",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "24px",
  textAlign: "left",
  marginBottom: "8px",
};

const SignUpModal = ({
  isOpen,
  onRequestClose,
  onLoggedIn,
  processing,
  handleGetUserLoginDetails,
  handleUserSignIn,
  register,
  getValues,
  handleSubmit,
  errors,
  setValue,
  step,
  setStep,
}) => {
  const [currentView, setCurrentView] = useState("login");
  const [forgotPasswordFlow, setForgotPasswordFlow] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [resetData, setResetData] = useState(null);
  const [activationData, setActivationData] = useState(null); // For registration OTP
  const [resendTimer, setResendTimer] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);

  const MERCHANT_ID = "MER12193";
  console.log(resetData, "ressss");

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // useEffect hook to switch to OTP to deal with the error of too many re-renders
  useEffect(() => {
    switch (step) {
      case 2:
        setCurrentView("otp");
        break;
      default:
        break;
    }
  }, [step]);

  const handleOTPChange = (element, index) => {
    if (isNaN(element.value)) return false;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Auto-focus to next input field after a digit is typed
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const handleForgotPassword = async () => {
    const phoneNumber = getValues("mobileNumber");

    if (!phoneNumber || phoneNumber.length !== 10) {
      toast.error("Please enter a valid phone number");
      return;
    }

    setIsProcessing(true);
    try {
      const payload = {
        contact: phoneNumber,
        cus_merchant: MERCHANT_ID,
      };

      const response = await putRequests.forgotPassword(payload);

      console.log(response, "toooooo");

      if (response?.status === 0 || response?.data) {
        setResetData(response?.id);
        setForgotPasswordFlow(true);
        setCurrentView("forgotPasswordOTP");
        setResendTimer(30);
        toast.success("OTP sent successfully!");
      } else {
        toast.error(response?.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      toast.error("Failed to send OTP. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleResendOTP = async () => {
    if (resendTimer > 0) return;

    const phoneNumber = getValues("mobileNumber");
    setIsProcessing(true);

    try {
      let response;

      if (forgotPasswordFlow) {
        // Resend OTP for password reset
        const payload = {
          contact: phoneNumber,
          cus_merchant: MERCHANT_ID,
        };
        response = await putRequests.forgotPassword(payload);

        if (response?.status === 0 || response?.data) {
          setResetData(response?.data);
          setResendTimer(30);
          toast.success("OTP resent successfully!");
        }
      } else {
        // Resend OTP for account activation
        const payload = {
          contact: phoneNumber,
          cus_merchant: MERCHANT_ID,
        };
        response = await putRequests.resendOTPtoActivateLoyaltyAccount(payload);

        if (response?.status === 0 || response?.data) {
          setActivationData(response?.data);
          setResendTimer(30);
          toast.success("OTP resent successfully!");
        }
      }

      if (response?.status !== 0 && !response?.data) {
        toast.error("Failed to resend OTP");
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      toast.error("Failed to resend OTP");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleOTPSubmit = async () => {
    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      toast.error("Please enter the complete OTP");
      return;
    }

    if (forgotPasswordFlow) {
      // Move to reset password screen
      setCurrentView("resetPassword");
      setValue("otpCode", otpCode);
    } else {
      // Registration flow - proceed to set password
      setCurrentView("login");
      setStep(3);
      setValue("otpCode", otpCode);
    }
  };

  const handleActivateUser = async () => {
    const password = getValues("password");
    const repeatPassword = getValues("repeatPassword");
    const otpCode = getValues("otpCode");
    console.log(otpCode, "otppp");
    const phoneNumber = getValues("mobileNumber");

    if (!password || !repeatPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    if (password !== repeatPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    setIsProcessing(true);
    try {
      const payload = {
        cus_phone: phoneNumber,
        cus_code: otpCode,
        cus_password: password,
        cus_merchant: MERCHANT_ID,
      };

      const response = await putRequests.activeLoyaltyUserAccount(payload);

      if (response?.status === 0) {
        toast.success(
          "Account activated successfully! Please login with your credentials.",
        );
        // Reset to login view
        setCurrentView("login");
        setOtp(Array(6).fill(""));
        setValue("password", "");
        setValue("repeatPassword", "");
        setValue("otpCode", "");
        setStep(1); // Set to step 1 so they can enter their password to login
        setForgotPasswordFlow(false);
      } else {
        toast.error(response?.message || "Failed to activate account");
      }
    } catch (error) {
      console.error("Account activation error:", error);
      toast.error("Failed to activate account. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleResetPassword = async () => {
    const password = getValues("password");
    const repeatPassword = getValues("repeatPassword");
    const otpCode = otp.join("");

    if (!password || !repeatPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    if (password !== repeatPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    setIsProcessing(true);
    try {
      const payload = {
        id: resetData,
        code: otpCode,
        new_pass: password,
        cus_merchant: MERCHANT_ID,
      };

      const response = await putRequests.resetPassword(payload);

      if (response?.status === 0) {
        toast.success("Password reset successfully!");
        setCurrentView("login");
        setForgotPasswordFlow(false);
        setOtp(Array(6).fill(""));
        setValue("password", "");
        setValue("repeatPassword", "");
        setValue("otpCode", "");
        setStep(0);
      } else {
        toast.error(response?.message || "Failed to reset password");
      }
    } catch (error) {
      console.error("Reset password error:", error);
      toast.error("Failed to reset password. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <div style={{ textAlign: "center" }}>
        {/* Toggle between Login and SignUp */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <button
            onClick={() => {
              setCurrentView("login");
              setForgotPasswordFlow(false);
              setStep(0);
            }}
            style={{
              marginRight: "10px",
              color: currentView === "login" ? "#204391" : "#98A2B3",
              fontSize: "16px",
              fontWeight: "600",
              fontFamily: "inter",
              padding: "8px",
              width: "100%",
            }}
          >
            Login
          </button>
        </div>
        <hr style={{ color: "gray", marginTop: "-8px", marginBottom: "8px" }} />
        {currentView === "login" && !forgotPasswordFlow && (
          // Login Form
          <>
            <div>
              <p style={headingStyle}>
                {step === 3 ? "Create Password" : "Welcome Back"}
              </p>
              <p style={textStyles}>
                {step === 3
                  ? "Set a password for your new account"
                  : "Enter your phone number and password"}
              </p>
            </div>
            <input
              readOnly={step === 1 || step === 3}
              placeholder="Phone Number"
              type="tel"
              maxLength={10}
              autoComplete="tel"
              style={inputStyles}
              {...register("mobileNumber", {
                required: "Mobile number is required",
                minLength: {
                  value: 10,
                  message: `Number must be 10 characters`,
                },
                maxLength: {
                  value: 10,
                  message: `Number must be 10 characters`,
                },
              })}
            />
            {step === 1 && (
              <>
                <input
                  type="password"
                  placeholder="Password"
                  autoComplete="current-password"
                  style={inputStyles}
                  {...register("password", {
                    required: "Password is required",
                  })}
                />
                <div style={{ textAlign: "right", marginBottom: "8px" }}>
                  <button
                    onClick={handleForgotPassword}
                    style={{
                      color: "#204391",
                      fontSize: "14px",
                      textDecoration: "underline",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                    disabled={isProcessing}
                  >
                    Forgot Password?
                  </button>
                </div>
              </>
            )}
            {step === 3 && (
              <>
                <input
                  type="password"
                  placeholder="New Password"
                  autoComplete="new-password"
                  style={inputStyles}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  })}
                />
                <input
                  type="password"
                  placeholder="Confirm Password"
                  style={inputStyles}
                  {...register("repeatPassword", {
                    required: "Password is required",
                    validate: (value) =>
                      value === getValues("password") || "Passwords must match",
                  })}
                />
                {errors.password && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {errors.password.message}
                  </p>
                )}
                {errors.repeatPassword && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {errors.repeatPassword.message}
                  </p>
                )}
              </>
            )}
            {step === 3 ? (
              <button
                disabled={isProcessing}
                style={{
                  ...buttonStyle,
                  background: isProcessing ? "#6BFA88" : "#3AC656",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(handleActivateUser)();
                }}
              >
                {!isProcessing ? "Activate Account" : "Loading..."}
              </button>
            ) : (
              <button
                disabled={processing}
                style={{
                  ...buttonStyle,
                  background: processing ? "#6BFA88" : "#3AC656",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(
                    step === 0 ? handleGetUserLoginDetails : handleUserSignIn,
                  )();
                }}
              >
                {!processing ? "Login" : "Loading..."}
              </button>
            )}
          </>
        )}

        {currentView === "otp" && (
          <>
            <h2 style={headingStyle}>Enter OTP</h2>
            <p style={textStyles}>
              Enter the code from the SMS we sent to {getValues("mobileNumber")}
            </p>
            <div>
              {otp.map((data, index) => {
                return (
                  <input
                    key={index}
                    type="text"
                    value={otp[index]}
                    maxLength="1"
                    onChange={(e) => handleOTPChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                    style={{
                      width: "40px",
                      height: "40px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      textAlign: "center",
                      fontSize: "18px",
                      border: "1px solid #E4E7EC",
                      borderRadius: "8px",
                    }}
                  />
                );
              })}
            </div>
            <button
              onClick={handleOTPSubmit}
              style={buttonStyle}
              disabled={isProcessing}
            >
              {isProcessing ? "Loading..." : "Confirm OTP"}
            </button>
            <div style={{ marginTop: "10px" }}>
              <button
                onClick={handleResendOTP}
                disabled={resendTimer > 0 || isProcessing}
                style={{
                  color: resendTimer > 0 ? "#98A2B3" : "#204391",
                  fontSize: "14px",
                  background: "none",
                  border: "none",
                  cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                }}
              >
                {resendTimer > 0
                  ? `Resend OTP in ${resendTimer}s`
                  : "Resend OTP"}
              </button>
            </div>
          </>
        )}

        {currentView === "forgotPasswordOTP" && (
          <>
            <h2 style={headingStyle}>Reset Password</h2>
            <p style={textStyles}>
              Enter the code from the SMS we sent to {getValues("mobileNumber")}
            </p>
            <div>
              {otp.map((data, index) => {
                return (
                  <input
                    key={index}
                    type="text"
                    value={otp[index]}
                    maxLength="1"
                    onChange={(e) => handleOTPChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                    style={{
                      width: "40px",
                      height: "40px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      textAlign: "center",
                      fontSize: "18px",
                      border: "1px solid #E4E7EC",
                      borderRadius: "8px",
                    }}
                  />
                );
              })}
            </div>
            <input
              type="password"
              placeholder="New Password"
              style={inputStyles}
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters",
                },
              })}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              style={inputStyles}
              {...register("repeatPassword", {
                required: "Password is required",
                validate: (value) =>
                  value === getValues("password") || "Passwords must match",
              })}
            />
            {errors.password && (
              <p style={{ color: "red", fontSize: "12px" }}>
                {errors.password.message}
              </p>
            )}
            {errors.repeatPassword && (
              <p style={{ color: "red", fontSize: "12px" }}>
                {errors.repeatPassword.message}
              </p>
            )}
            <button
              onClick={handleSubmit(handleResetPassword)}
              style={buttonStyle}
              disabled={isProcessing}
            >
              {isProcessing ? "Loading..." : "Reset Password"}
            </button>
            <div style={{ marginTop: "10px" }}>
              <button
                onClick={handleResendOTP}
                disabled={resendTimer > 0 || isProcessing}
                style={{
                  color: resendTimer > 0 ? "#98A2B3" : "#204391",
                  fontSize: "14px",
                  background: "none",
                  border: "none",
                  cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                }}
              >
                {resendTimer > 0
                  ? `Resend OTP in ${resendTimer}s`
                  : "Resend OTP"}
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default SignUpModal;
